module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "inbox"
  }, [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("欢迎使用VBAdmin ")])]), _vm._v(" "), _c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_c('bsf-note', {
    attrs: {
      "data": _vm.noteData,
      "type": "hasol"
    }
  })]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "9"
    }
  }, [_c('bsf-layout', {
    staticClass: "cavmix-box"
  }, [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "9"
    }
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "200",
      "data": _vm.chartData1.chart,
      "ctype": "line",
      "areaStyle": true,
      "toolbox": false
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.chartData1.chartmsg))])]), _vm._v(" "), _c('bsf-col', {
    staticClass: "countmsg",
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_vm._l((_vm.chartData1.chart), function(count, index) {
    return [_c('h3', [_vm._v(" $" + _vm._s(_vm._f("count")(count.data)) + "000")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(count.name))]), _vm._v(" "), _c('bsf-progress', {
      attrs: {
        "state": 70,
        "end": true,
        "type": "info",
        "striped": "",
        "animate": ""
      }
    })]
  })], true)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "2"
    }
  }, [_c('bsf-panel', {
    staticClass: "titinfo"
  }, [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("浏览量"), _c('bsf-label', {
    staticClass: "pull-right",
    attrs: {
      "type": "success"
    }
  }, [_vm._v("本周")])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('h2', {
    staticClass: "tits"
  }, [_vm._v("25,600")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("总浏览量"), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("206"), _c('icon', {
    attrs: {
      "icon": "arrow-top-b"
    }
  })])])])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "2"
    }
  }, [_c('bsf-panel', {
    staticClass: "titinfo"
  }, [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("注册量"), _c('bsf-label', {
    staticClass: "pull-right",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("今日")])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('h2', {
    staticClass: "tits"
  }, [_vm._v("25,600")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("总浏览量"), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("206"), _c('icon', {
    attrs: {
      "icon": "arrow-top-b"
    }
  })])])])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    staticClass: "titinfo"
  }, [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 ")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-layout', [_c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('h2', {
    staticClass: "tits"
  }, [_vm._v("25,600")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("总浏览量"), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("206"), _c('icon', {
    attrs: {
      "icon": "arrow-top-b"
    }
  })])])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('h2', {
    staticClass: "tits"
  }, [_vm._v("25,600")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("总浏览量"), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("206"), _c('icon', {
    attrs: {
      "icon": "arrow-top-b"
    }
  })])])])])])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "fullcav": true
    }
  }, [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("图表 Echart")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "98",
      "data": _vm.chartData1.chart,
      "ctype": "line",
      "fullcav": true,
      "legend": false,
      "areaStyle": false,
      "toolbox": false,
      "x": false,
      "y": false,
      "tooltip": false
    }
  })])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "12"
    }
  }, [_c('bsf-panel', {
    staticClass: "titinfo",
    attrs: {
      "hashead": false
    }
  }, [_c('div', {
    staticClass: "cavmix-box",
    slot: "body"
  }, [_c('bsf-col', {
    staticClass: "tits",
    attrs: {
      "size": "xs",
      "col": "12"
    }
  }, [_c('span', {
    staticClass: "pull-right text-right"
  }, [_c('small', [_vm._v("Average value of sales in the past month in: United states ")]), _vm._v(" "), _c('br'), _vm._v("All sales: 162,862\n\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    staticClass: "tit"
  }, [_vm._v("图表的完整名称主标题在这里")]), _vm._v(" "), _c('h5', {
    staticClass: "tit1"
  }, [_vm._v("图表的副标题")])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "9"
    }
  }, [_c('bsf-chart', {
    attrs: {
      "cheight": "200",
      "data": _vm.chartData1.chart,
      "ctype": "line",
      "areaStyle": true,
      "toolbox": false
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.chartData1.chartmsg))])]), _vm._v(" "), _c('bsf-col', {
    staticClass: "countmsg",
    attrs: {
      "size": "xs",
      "col": "3"
    }
  }, [_vm._l((_vm.chartData1.chart), function(count, index) {
    return [_c('h3', [_vm._v(" $" + _vm._s(_vm._f("count")(count.data)) + "000")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(count.name))]), _vm._v(" "), _c('bsf-progress', {
      attrs: {
        "state": 70,
        "end": true,
        "type": "info",
        "striped": "",
        "animate": ""
      }
    })]
  })], true)])])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("对话列表"), _c('bsf-label', {
    staticClass: "pull-right",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("您有" + _vm._s(_vm.userMsg.length) + "条对话")])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-media-list', _vm._l((_vm.userMsg), function(item, index) {
    return _c('bsf-media', {
      attrs: {
        "data": item,
        "circle": true,
        "hasright": true,
        "middle": true
      }
    })
  }))])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("消息列表"), _c('bsf-label', {
    staticClass: "pull-right",
    attrs: {
      "type": "success"
    }
  }, [_vm._v("您有" + _vm._s(_vm.userMsg.length) + "条消息")])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-media-list', [_vm._l((_vm.msgmix), function(item, index) {
    return _c('bsf-media', {
      attrs: {
        "data": item,
        "type": "unhead"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.msgmix), function(item, index) {
    return _c('bsf-media', {
      attrs: {
        "data": item,
        "type": "unhead",
        "time": "bottom"
      }
    })
  })], true)])], true)]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "unbg": true
    }
  }, [_c('h5', {
    staticClass: "panel-title",
    slot: "title"
  }, [_vm._v("聊天对话")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('bsf-media-list', {
    attrs: {
      "type": "chat"
    }
  }, _vm._l((_vm.chat), function(item, index) {
    return _c('bsf-media', {
      class: {
        guest: !!item.guest
      },
      attrs: {
        "hasright": item.guest
      }
    }, [(!item.guest) ? _c('template', {
      slot: "left"
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": require("../../assets/imgs/profilepicture.jpg")
      }
    })]) : _c('template', {
      slot: "right"
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": require("../../assets/imgs/profilepicture.jpg")
      }
    })]), _vm._v(" "), _vm._v(" "), _c('template', {
      slot: "body"
    }, [_c('p', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.username))]), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.content))])])], true)
  }))])], true)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-334256c8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/temp/temp1.vue
// module id = 304
// module chunks = 2